import { Box, Paper, Grid, Typography } from "@mui/material";
import { pcsEnrolmentStatusEnum } from "../../app/enums/pcsEnrolmentStatusEnum";

interface Props {
    reenrol: boolean;
    pcsEnrolmentStatus: string | undefined;
}

export default function PcsDetailsMessages({ reenrol, pcsEnrolmentStatus }: Props) {

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>

            <Grid container rowSpacing={4}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
                    <Typography variant='h4'>
                        {reenrol === true ? 'Professional Competence Scheme re-enrolment' :
                            'Professional Competence Scheme Enrolment'}
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%', marginRight: '2%', marginBottom: '2%' }}>
                    <Typography variant='subtitle1'>
                        {pcsEnrolmentStatus === pcsEnrolmentStatusEnum.Pending &&
                            <>
                                Thank you for your PCS Application. Please check your email for next steps.
                                Please note - you will have full access to your PCS dashboard, once approved
                                by the team.
                            </>
                        }
                    </Typography>
                </Grid>

            </Grid>
        </Box>
    </>
}
